import { COMPETENCY_LABELS } from '@/lib/competency'
import { cn } from '@/lib/utils'
import type { Competency } from '@/types/interview'

interface CompetencyBadgeProps {
  competency: Competency
  className?: string
}

export function CompetencyBadge({ competency, className }: CompetencyBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary',
        className
      )}
    >
      {COMPETENCY_LABELS[competency]}
    </span>
  )
}
